/**
 * Created by jv on 22/03/2017.
 */
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");
const ElementCreator = require("Sources/components/element-creator");
const Dialog = require("Sources/utils/modal");
const InputSpinner = require("Sources/components/input-spinner");

require("Styles/components/shopping-cart-v2.scss");

module.exports = class CartTemplate
{
  constructor(options)
  {
    /*
     * options.appendTo
     * options.cart (Cart object [models/store/cart.js])
     *
     * options.setItemQuantity(key, quantity)
     */

    if(utils.isNull(options) || utils.isNull(options.sessionData))
    {
      throw "options must be defined with a valid SessionData object";
    }

    this.appendTo = $(options.appendTo);
    this.sessionData = options.sessionData;
    this.cart = this.sessionData.cart;

    this.editable = options.editable;

    this.canBeGroupPurchase = utils.isBoolean(options.canBeGroupPurchase) ? options.canBeGroupPurchase : false;

    this.setItemQuantity = options.setItemQuantity;
    this.removeItem = options.removeItem;
    this.setItemGroupPurchase = options.setItemGroupPurchase;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.cartWrapperEl = $("<div class='shopping-cart-wrapper'></div>");
      this.cartPriceSummaryEl = $("<div class='price-summary'></div>");
      this.appendTo.append(this.cartWrapperEl).append(this.cartPriceSummaryEl);

      this.refresh();

      this._initialized = true;
    }
  }

  show()
  {
    if(utils.isNotNull(this.cartWrapperEl) && this.cartWrapperEl.length)
    {
      this.cartWrapperEl.show();
    }

    if(utils.isNotNull(this.cartPriceSummaryEl) && this.cartPriceSummaryEl.length)
    {
      this.cartPriceSummaryEl.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.cartWrapperEl) && this.cartWrapperEl.length)
    {
      this.cartWrapperEl.hide();
    }

    if(utils.isNotNull(this.cartPriceSummaryEl) && this.cartPriceSummaryEl.length)
    {
      this.cartPriceSummaryEl.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.cartWrapperEl) && this.cartWrapperEl.length)
    {
      this.cartWrapperEl.destroy();
    }

    if(utils.isNotNull(this.cartPriceSummaryEl) && this.cartPriceSummaryEl.length)
    {
      this.cartPriceSummaryEl.destroy();
    }

    this._initialized = false;
  }

  refresh()
  {
    this.cartWrapperEl.empty();
    this.cartPriceSummaryEl.empty();

    this.renderCart();
    this.renderPriceSummary();
    this.setUpEventListeners();
  }

  reload(sessionData)
  {
    this.sessionData = sessionData;
    this.cart = this.sessionData.cart;
    this.refresh();
  }

  renderPriceSummary()
  {
    this.cartPriceSummaryEl.append(this.createPriceRow(LanguageManager.getValueForKey("store.cart.price_summary.subtotal") + ":", utils.roundNumber(this.cart.subtotal, 2)));

    if(utils.isNotNull(this.cart.deliveryCosts))
    {
      this.cartPriceSummaryEl.append(this.createPriceRow(this.cart.deliveryCosts.article.title + ":", utils.roundNumber(this.cart.deliveryCosts["price-without-vat"], 2)));
    }

    if(utils.isArray(this.cart.discounts))
    {
      for(var i = 0; i < this.cart.discounts.length; i++)
      {
        this.cartPriceSummaryEl.append(this.createPriceRow(this.cart.discounts[i].article.title + ":", utils.roundNumber(this.cart.discounts[i]["price-without-vat"], 2), [ "candy-pink" ]));
      }
    }

    if(utils.isArray(this.cart.vatList))
    {
      for(var i = 0; i < this.cart.vatList.length; i++)
      {
        this.cartPriceSummaryEl.append(this.createPriceRow(LanguageManager.getValueForKey("store.cart.price_summary.vat") + " " + (this.cart.vatList[i].vat * 100) + "%:", utils.roundNumber(this.cart.vatList[i].value, 2)));
      }
    }

    // this.cartPriceSummaryEl.append(this.createPriceRow(LanguageManager.getValueForKey("store.cart.price_summary.vat") + ":", utils.roundNumber(this.cart.totalVat, 2)));
    this.cartPriceSummaryEl.append(this.createPriceRow(LanguageManager.getValueForKey("store.cart.price_summary.total") + ":", utils.roundNumber(this.cart.totalPriceVat, 2), [ "total-price", "top-space", "sky-blue" ]));
  }

  createPriceRow(label, price, extraClasses)
  {
    var labelEl = ElementCreator.createStringElement({
      classNames: [ "price-label" ],
      innerHTML: label
    });

    var priceEl = ElementCreator.createStringElement({
      classNames: [ "price-value" ],
      innerHTML: this.cart.currency + " " + price.toFixed(2)
    });

    return ElementCreator.createStringElement({
      classNames: [ "price-row" ].concat(extraClasses),
      innerHTML: labelEl + priceEl
    });
  }

  renderCart()
  {
    this.renderCartHeader();

    this.renderCartItems();
  }

  renderCartHeader()
  {
    var headerRow = $("<div class='header-row'></div>");

    var headerLeft = $("<div class='flex-left'></div>");

    var flexGroup = $("<div class='flex-group flex-5'></div>");
    flexGroup.append("<div class='header-label product-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.product") + "</div>");

    if(this.canBeGroupPurchase)
    {
      flexGroup.append("<div class='header-label group-purchase-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.group_purchase") + "</div>");
    }

    headerLeft.append(flexGroup);

    headerLeft.append("<div class='header-label price-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.price") + "</div>");
    headerLeft.append("<div class='header-label quantity-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.quantity") + "</div>");
    headerRow.append(headerLeft);

    var headerRight = $("<div class='flex-right'></div>");
    // headerRight.append("<div class='header-label price-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.price") + "</div>");
    // headerRight.append("<div class='header-label quantity-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.quantity") + "</div>");
    headerRight.append("<div class='header-label total-price-label'>" + LanguageManager.getValueForKey("store.cart.header.labels.total_price") + "</div>");
    headerRow.append(headerRight);

    this.cartWrapperEl.append(headerRow);
  }

  renderCartItems()
  {
    for(var i = 0; i < this.cart.items.length; i++)
    {
      this.cartWrapperEl.append(this.renderCartItem(this.cart.items[i]));
    }

    for(var i = 0; i < this.cart.freeArticles.length; i++)
    {
      this.cartWrapperEl.append(this.renderFreeItem(this.cart.freeArticles[i]));
    }
  }

  renderCartItem(item)
  {
    var cartItemEl = $("<div class='cart-item'></div>").attr("data-cart-item", item.article.key);

    var cartItemLeftEl = $("<div class='flex-left'></div>");
    var flexGroup = $("<div class='flex-group'></div>");
    var cartItemRightEl = $("<div class='flex-right'></div>");

    this.createItemImage(item, cartItemLeftEl);
    this.createItemInfo(item, flexGroup);

    if(this.canBeGroupPurchase)
    {
      this.createPurchaseOrderCheck(item, flexGroup);
    }

    cartItemLeftEl.append(flexGroup);

    this.createItemPrice(item, cartItemLeftEl);
    this.createItemQuantity(item, cartItemLeftEl);
    // this.createItemVAT(item, cartItemRightEl);
    this.createItemTotalPrice(item, cartItemRightEl);
    this.createItemRemove(item, cartItemRightEl);

    cartItemEl.append(cartItemLeftEl);
    cartItemEl.append(cartItemRightEl);

    return cartItemEl;
  }

  renderFreeItem(item)
  {
    var cartItemEl = $("<div class='cart-item'></div>").attr("data-cart-item", item.article.key);

    var cartItemLeftEl = $("<div class='flex-left'></div>");
    var flexGroup = $("<div class='flex-group'></div>");
    var cartItemRightEl = $("<div class='flex-right'></div>");

    this.createItemImage(item, cartItemLeftEl);
    this.createItemInfo(item, flexGroup);


    cartItemLeftEl.append(flexGroup);

    // price no vat
    cartItemLeftEl.append("<div class='item-cell item-price'><div>" + this.cart.currency + " " + utils.roundNumber(item["price-without-vat"], 2).toFixed(2) + "</div></div>");

    // quantity
    var quantityEl = $("<div class='item-cell item-quantity'></div>");
    quantityEl.append("<div>" + item.count + "</div>");
    cartItemLeftEl.append(quantityEl);

    // total price
    cartItemRightEl.append("<div class='item-cell item-total-price'><div>" + this.cart.currency + " " + utils.roundNumber(item["price-without-vat"] * item.count, 2).toFixed(2) + "</div></div>")

    cartItemEl.append(cartItemLeftEl);
    cartItemEl.append(cartItemRightEl);

    return cartItemEl;
  }

  createItemImage(item, appendTo)
  {
    // Moved to createItemInfo so it aligns with the header row
    // appendTo.append("<div class='item-cell item-image'><img src='" + item.article.image + "'/></div>");
  }

  createItemInfo(item, appendTo)
  {
    appendTo.append("<div class='item-cell item-image'><img src='" + item.article.image + "'/></div>");

    if (utils.isNullOrEmpty(item.comment))
      appendTo.append("<div class='item-cell item-info'><div>" + item.article.title + "</div></div>");
    else
      appendTo.append("<div class='item-cell item-info'><div>" + item.article.title + "<br/><i>" + item.comment + "</i></div></div>");
  }

  createPurchaseOrderCheck(item, appendTo)
  {
    var checkboxId = item.article.key + "-group-purchase-check";
    appendTo.append("<div class='item-cell item-group-purchase'><div><div class='form-group'><input id='" + checkboxId + "' type='checkbox' name='article-group-purchase-check'><label for='" + checkboxId + "'>" + LanguageManager.getValueForKey("store.cart.items.labels.group_purchase") + "</label></div></div></div>");
  }

  createItemPrice(item, appendTo)
  {
    appendTo.append("<div class='item-cell item-price'><div>" + this.cart.currency + " " + utils.roundNumber(item.article.priceNoVat, 2).toFixed(2) + "</div></div>");
  }

  createItemQuantity(item, appendTo)
  {
    var quantityEl = $("<div class='item-cell item-quantity'></div>");

    if(this.editable && !item.article.purchaseOnce)
    {
      var spinner = new InputSpinner({
        appendTo: quantityEl,
        initialValue: item.quantity,
        minValue: 1,
        maxValue: item.article.purchaseOnce ? 1 : utils.getMaxSafeInt()
      });
    }
    else
    {
      quantityEl.append("<div>" + item.quantity + "</div>");
    }

    appendTo.append(quantityEl);
  }

  createItemVAT(item, appendTo)
  {
    appendTo.append("<div class='item-cell item-vat'><span>" + LanguageManager.getValueForKey("store.cart.vat") + " " + item.article.vatPercentage + "%" + "</span></div>");
  }

  createItemTotalPrice(item, appendTo)
  {
    appendTo.append("<div class='item-cell item-total-price'><div>" + this.cart.currency + " " + utils.roundNumber(item.priceNoVat, 2).toFixed(2) + "</div></div>")
  }

  createItemRemove(item, appendTo)
  {
    var removeCell = $("<div class='item-cell item-remove'></div>");

    if(this.editable)
    {
      removeCell.append("<button class='btn btn-icon frameless trash-o dark-grey' type='button'></button>");
    }

    appendTo.append(removeCell);
  }

  setUpEventListeners()
  {
    var that = this;

    this.cartWrapperEl.find(".item-remove .btn.btn-icon.trash-o").off().on("click", function(e)
    {
      if(utils.isFunction(that.removeItem))
      {
        that.removeItem($(this).closest(".cart-item").attr("data-cart-item"));
      }
    });

    this.cartWrapperEl.find(".item-group-purchase input[name='article-group-purchase-check']").off().on("change", function(e)
    {
      if(utils.isFunction(that.setItemGroupPurchase))
      {
        that.setItemGroupPurchase($(this).closest(".cart-item").attr("data-cart-item"), this.checked);
      }
    });

    this.cartWrapperEl.find(".item-quantity .input-spinner").off().on("spinner:change", function(e, spinner)
    {
      var thisEl = $(this);
      var key = thisEl.closest(".cart-item").attr("data-cart-item");
      var item = that.cart.getItemForKey(key);
      var quantity = spinner.value;

      if(item.article.purchaseOnce === true)
      {
        Dialog.showMessageDialog("store.cart.purchase_once.dialog.title", "store.cart.purchase_once.dialog.text");
        thisEl.val(1);
        e.preventDefault();
        return;
      }

      if(utils.isFunction(that.setItemQuantity) && utils.isNumber(quantity))
      {
        that.setItemQuantity(key, quantity);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./app/js/templates/store-cart-v2.template.js